import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { TGenerateLewkboardsRequest } from "../../../../b2c-api/src/routers/lewkboards";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

interface propTypes {
  disableProgress: React.Dispatch<React.SetStateAction<boolean>>;
  handleStepChange: (index: number) => void;
}

const FormOccassionStep: React.FC<propTypes> = ({
  disableProgress,
  handleStepChange,
}) => {
  // ---------------------------- DATA ---------------------------- //
  const EXAMPLE_OCCASSIONS: string[] = [
    "Looking for a stylish, casual weekend look",
    "I want to find a professional outfit for work",
    'Minimalist chic for a night out'
  ];

  // ---------------------------- HOOKS ---------------------------- //
  const { register, setValue, watch } =
    useFormContext<TGenerateLewkboardsRequest>();
  const watchOccasion = watch("occassion");

  // ---------------------------- FUNCTIONS ---------------------------- //
  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (watchOccasion && watchOccasion.length >= 3) {
        handleStepChange(2);
      }
    }
  };
  // ---------------------------- USE EFFECT ---------------------------- //
  useEffect(() => {
    if (watchOccasion && watchOccasion.length >= 3) {
      disableProgress(false);
    } else {
      disableProgress(true);
    }

    return () => {
      disableProgress(true);
    };
  }, [watchOccasion]);
  return (
    <div className="flex flex-col gap-4 h-full justify-center">
      <Label className=" text-center" variant={"multistep"}>
        What are you shopping for?
      </Label>
      <Textarea
        rows={3}
        onKeyDown={handleKeyDown}
        className=" w-full placeholder:text-lewk-darkgrey"
        placeholder="Ex… I'm shopping for a wedding guest outfit"
        {...register("occassion", { required: true })}
      />
      <div className=" flex flex-col gap-1">
        <p className=" text-xs text-lewk-darkgrey">Suggested:</p>
        <div className=" flex flex-wrap gap-1 justify-left ">
          {EXAMPLE_OCCASSIONS.map((occassion, index) => (
            <Button
              onClick={() => setValue("occassion", occassion)}
              className=" max-w-full"
              key={index}
              type="button"
              variant={"secondary"}
              size={"sm"}
            >
              <p className=" w-full text-xs truncate">{occassion}</p>
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FormOccassionStep;
